import { Crown } from 'lucide-react';

// Shown next to ConnectionPill when the local user opened the board directly
// (no `#join=<code>` in the URL at mount). The concept is local-session-only:
// "did *this tab* originate the board, or did it arrive via an invite?". Two
// tabs of the same browser can both be "host" — that's fine.
export function HostPill() {
  return (
    <div
      role="status"
      className="
        h-6 px-2.5 inline-flex items-center gap-1.5
        rounded-2 border-1.5 border-border-default
        bg-accent-subtle text-accent
        font-mono text-12 tabular-nums
      "
    >
      <Crown size={12} strokeWidth={1.5} />
      You are the host
    </div>
  );
}
